import { Component, Input } from "@angular/core"
import { PremiumFooterSection } from "../../../models/collection/premiumFooterSection.model"
import { PremiumColors } from "../../../models/collection/premiumColors.model"

@Component({
    selector: "app-premium-footer-links",
    templateUrl: "./footer-links.component.html",
    styleUrls: ["./footer-links.component.scss"],
    standalone: false,
})
export class FooterLinksComponent {
    imgBackgroundStyle: any = {}
    @Input() public colors: PremiumColors = null
    section: PremiumFooterSection

    @Input()
    public set footerSection(value: PremiumFooterSection) {
        this.section = value
        if (this.section) {
            this.imgBackgroundStyle = {
                "background-image": "url('" + this.section.image.resize("", 400) + "')",
                "background-color": this.colors ? this.colors.footerColor : null,
            }
        } else {
            this.imgBackgroundStyle = {}
        }
    }
}
